import { render, staticRenderFns } from "./date-picker-months.vue?vue&type=template&id=87324be2&scoped=true&"
import script from "./date-picker-months.vue?vue&type=script&lang=js&"
export * from "./date-picker-months.vue?vue&type=script&lang=js&"
import style0 from "./date-picker-months.vue?vue&type=style&index=0&id=87324be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87324be2",
  null
  
)

export default component.exports